/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/passwordGenerators.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Password generation utilities for Extensions module.
────────────────────────────────────────────────────────────────*/

/**
 * Generates a random 5-digit password starting with *
 * Format: *XXXX (where XXXX is 4 random digits 1000-9999)
 */
export function generateDefaultPassword(): string {
  const digits = Math.floor(1000 + Math.random() * 9000); // Generate 4 random digits (1000-9999)
  return `*${digits}`;
}

/**
 * Generates a random alphanumeric password
 * Length: 15 characters (max for SIP device compatibility)
 */
export function generateDefaultSecret(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const length = 15; // Fixed 15 characters for SIP device compatibility

  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
}

/**
 * Generates a random 4-digit voicemail PIN
 * Format: XXXX (where XXXX is 1000-9999)
 */
export function generateVoicemailPin(): string {
  return Math.floor(1000 + Math.random() * 9000).toString(); // 1000-9999
}

